// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICensusReportErrorDetailsDto
 */
export interface ICensusReportErrorDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ICensusReportErrorDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICensusReportErrorDetailsDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ICensusReportErrorDetailsDto
     */
    error_code?: string;
}

/**
 * Check if a given object implements the ICensusReportErrorDetailsDto interface.
 */
export function instanceOfICensusReportErrorDetailsDto(value: object): value is ICensusReportErrorDetailsDto {
    return true;
}

export function ICensusReportErrorDetailsDtoFromJSON(json: any): ICensusReportErrorDetailsDto {
    return ICensusReportErrorDetailsDtoFromJSONTyped(json, false);
}

export function ICensusReportErrorDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusReportErrorDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'message': json['message'] == null ? undefined : json['message'],
        'error_code': json['errorCode'] == null ? undefined : json['errorCode'],
    };
}

export function ICensusReportErrorDetailsDtoToJSON(json: any): ICensusReportErrorDetailsDto {
    return ICensusReportErrorDetailsDtoToJSONTyped(json, false);
}

export function ICensusReportErrorDetailsDtoToJSONTyped(value?: ICensusReportErrorDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'message': value['message'],
        'errorCode': value['error_code'],
    };
}

